import { render, staticRenderFns } from "./order-invoice.vue?vue&type=template&id=d55c39a8&scoped=true"
import script from "./order-invoice.vue?vue&type=script&lang=js"
export * from "./order-invoice.vue?vue&type=script&lang=js"
import style0 from "./order-invoice.vue?vue&type=style&index=0&id=d55c39a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d55c39a8",
  null
  
)

export default component.exports